export const SET_SELECTION_DATA = 'SET_SELECTION_DATA';
export const SELECTION_SLIDERS_UPDATE = 'SELECTION_SLIDERS_UPDATE';
export const SET_PREMIUMS = 'SET_PREMIUMS';
export const UPDATE_TABLE_INDEXES = 'UPDATE_TABLE_INDEXES';
export const SET_IS_LOADING = 'SET_IS_LOADING';
